module.exports = __webpack_public_path__ + "static/media/pf.bab3b7a5.svg";